import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal",
  style: {"width":"1020px"}
}
const _hoisted_4 = { class: "modal__content pa-1" }
const _hoisted_5 = { class: "stepper--bar" }
const _hoisted_6 = { class: "stepper--bar__header" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "1", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Subscription Info", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "2", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Company Info", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "3", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Payment Info", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "4", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Submit", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "pa--y-1 pa--left-1" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Enter Subscription Information"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text--style-italic",
    style: {"font-size":"80%"}
  })
], -1)
const _hoisted_27 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_28 = { class: "form-field__outline--control" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("b", null, "Select Project :- ", -1)
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "form-field form-field__outline--control ma--x-1" }
const _hoisted_32 = { class: "form-checkbox" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  style: {"font-size":"small","color":"gray"},
  for: "isStartSubscriptionImmediately"
}, "Start Immediately", -1)
const _hoisted_34 = { class: "form-field__outline--control" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "start-date",
  class: "form-field__outline--control__label"
}, "Start Date (MM/DD/YYYY)", -1)
const _hoisted_37 = { class: "form-field__outline--control" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-param",
  class: "form-field__outline--control__label"
}, "End Date (MM/DD/YYYY)", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}, "   Minimum subscription duration of 6 months. ", -1)
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-param",
  class: "form-field__outline--control__label"
}, "$ 0.00", -1)
const _hoisted_43 = {
  key: 0,
  class: "stepper--bar__content--label__info--message__data color--primary-red",
  style: {"font-size":"14px"}
}
const _hoisted_44 = { class: "stepper--bar__content" }
const _hoisted_45 = { class: "pa--y-1 pa--left-1" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Enter Company Information"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text--style-italic",
    style: {"font-size":"80%"}
  })
], -1)
const _hoisted_47 = { style: {"margin":"3px 0"} }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("b", null, "Project :- ", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_51 = { class: "form-field__outline--control" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("b", null, "Customer:- ", -1)
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "form-field__outline--control" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-param",
  class: "form-field__outline--control__label"
}, "Address", -1)
const _hoisted_56 = { class: "form-field__outline--control" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-param",
  class: "form-field__outline--control__label"
}, "City", -1)
const _hoisted_58 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_59 = { class: "form-field__outline--control" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("b", null, "State:- ", -1)
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "form-field__outline--control" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-param",
  class: "form-field__outline--control__label"
}, "Zip Code", -1)
const _hoisted_64 = { class: "pa--y-1 pa--left-1" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Enter Payment Information"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text--style-italic",
    style: {"font-size":"80%"}
  })
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { for: "cardPayment" }, "Credit Card", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { for: "bankAccountPayment" }, "Bank Account", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = { class: "stepper--bar__content--label__info" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "stepper--bar__content--label__info--message pa-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Subscription Information")
], -1)
const _hoisted_72 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_73 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_74 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_75 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_76 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_77 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "stepper--bar__content--label__info--message pa-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Billing Infomation")
], -1)
const _hoisted_79 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_80 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_81 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_82 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_83 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_84 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_85 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_86 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_87 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_88 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_89 = { class: "modal__footer" }
const _hoisted_90 = {
  key: 0,
  class: "stepper--bar__content--label__info--error ma--x-5"
}
const _hoisted_91 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stripe_checkout = _resolveComponent("stripe-checkout")!
  const _directive_outline = _resolveDirective("outline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" d "),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 1,
                })
              }, _hoisted_9, 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 2,
                })
              }, _hoisted_12, 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 3,
                })
              }, _hoisted_15, 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 4,
                })
              }, _hoisted_18, 2)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-1", {
                'label--active': _ctx.stepper == 1,
              }])
          }, [
            _hoisted_19,
            _hoisted_20,
            _hoisted_21,
            _hoisted_22,
            _hoisted_23,
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-field__outline--control__select",
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateOnProjectSelection())),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.siteId) = $event)),
                    style: {"width":"230px"}
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites.data, (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: item.id
                      }, _toDisplayString(item.siteName), 9, _hoisted_30))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.siteId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isStartSubscriptionImmediately) = $event)),
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.executeStartDateUpdate()))
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.isStartSubscriptionImmediately]
                  ]),
                  _hoisted_33
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__outline--active ma--x-1", {
                      'form-field__outline--invalid': _ctx.v$.stripeSubscriptionInfo.startDate.$error,
                      'form-field__outline--active': !_ctx.v$.stripeSubscriptionInfo.startDate.$invalid,
                  }])
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-field__outline--control__input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.stripeSubscriptionInfo.startDate) = $event)),
                    disabled: _ctx.siteSubscriptionAlreadyPresent==true ||_ctx.isStartSubscriptionImmediately,
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkStartDateIfValid(_ctx.v$.stripeSubscriptionInfo.startDate.$invalid))),
                    style: {"width":"400px"}
                  }, null, 40, _hoisted_35), [
                    [_vModelText, _ctx.stripeSubscriptionInfo.startDate],
                    [_directive_outline]
                  ]),
                  _hoisted_36
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__outline--active ma--x-1", {
                'form-field__outline--invalid': _ctx.v$.stripeSubscriptionInfo.endDate.$error,
                'form-field__outline--active': !_ctx.v$.stripeSubscriptionInfo.endDate.$invalid,
                }])
              }, [
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-field__outline--control__input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.stripeSubscriptionInfo.endDate) = $event)),
                    disabled: _ctx.siteSubscriptionAlreadyPresent==true,
                    onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkEndDateIfValid(_ctx.v$.stripeSubscriptionInfo.endDate.$invalid))),
                    style: {"width":"400px"}
                  }, null, 40, _hoisted_38), [
                    [_vModelText, _ctx.stripeSubscriptionInfo.endDate],
                    [_directive_outline]
                  ]),
                  _hoisted_39,
                  _hoisted_40
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__outline--active ma--x-1", {
                'form-field__outline--invalid': _ctx.v$.amountRequest.dollarAmount.$error,
                'form-field__outline--active': !_ctx.v$.amountRequest.dollarAmount.$invalid,
                }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-field__outline--control__input",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.amountRequest.dollarAmount) = $event)),
                  disabled: _ctx.siteSubscriptionAlreadyPresent==true,
                  style: {"width":"400px"}
                }, null, 8, _hoisted_41), [
                  [_vModelText, _ctx.amountRequest.dollarAmount],
                  [_directive_outline]
                ]),
                _hoisted_42,
                (!!_ctx.amountRequest.dollarAmount&&!_ctx.checkAmountIfValid(_ctx.v$.amountRequest.dollarAmount.$invalid))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, "   " + _toDisplayString(_ctx.amountMessage), 1))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ], 2),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", {
              class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-2", {
                'label--active': _ctx.stepper == 2,
              }])
            }, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("p", _hoisted_47, [
                  _hoisted_48,
                  _createTextVNode(_toDisplayString(_ctx.selectedSite.siteName), 1)
                ]),
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-field__outline--control__select",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedEmail) = $event)),
                      style: {"width":"310px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userEmailMap, ([key, value]) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: key,
                          value: key
                        }, _toDisplayString(value.firstName) + " " + _toDisplayString(value.lastName) + "(" + _toDisplayString(value.email) + ") ", 9, _hoisted_53))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedEmail]
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field form-field__outline ma--x-1", {
                'form-field__outline--invalid': _ctx.v$.stripeCustomerInfo.address.$error,
                'form-field__outline--active': !_ctx.v$.stripeCustomerInfo.address.$invalid,
                }])
                }, [
                  _createElementVNode("div", _hoisted_54, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__outline--control__input",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.stripeCustomerInfo.address) = $event)),
                      style: {"width":"400px"}
                    }, null, 512), [
                      [_vModelText, _ctx.stripeCustomerInfo.address],
                      [_directive_outline]
                    ]),
                    _hoisted_55
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field form-field__outline ma--x-1", {
                'form-field__outline--invalid': _ctx.v$.stripeCustomerInfo.city.$error,
                'form-field__outline--active': !_ctx.v$.stripeCustomerInfo.city.$invalid,
                }])
                }, [
                  _createElementVNode("div", _hoisted_56, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__outline--control__input",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.stripeCustomerInfo.city) = $event)),
                      style: {"width":"400px"}
                    }, null, 512), [
                      [_vModelText, _ctx.stripeCustomerInfo.city],
                      [_directive_outline]
                    ]),
                    _hoisted_57
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-field__outline--control__select",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.stripeCustomerInfo.state) = $event)),
                      style: {"width":"250px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateList, (item, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: item
                        }, _toDisplayString(item), 9, _hoisted_61))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.stripeCustomerInfo.state]
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field form-field__outline ma--x-1", {
                'form-field__outline--invalid': _ctx.v$.stripeCustomerInfo.zipCode.$error,
                'form-field__outline--active': !_ctx.v$.stripeCustomerInfo.zipCode.$invalid,
                }])
                }, [
                  _createElementVNode("div", _hoisted_62, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__outline--control__input",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.stripeCustomerInfo.zipCode) = $event)),
                      style: {"width":"400px"}
                    }, null, 512), [
                      [_vModelText, _ctx.stripeCustomerInfo.zipCode],
                      [_directive_outline]
                    ]),
                    _hoisted_63
                  ])
                ], 2)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-3", {
                'label--active': _ctx.stepper == 3,
              }])
            }, [
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "cardPayment",
                  value: "card",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.stripeRequest.paymentType) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.stripeRequest.paymentType]
                ]),
                _hoisted_66,
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "bankAccountPayment",
                  value: "bankAccount",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.stripeRequest.paymentType) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.stripeRequest.paymentType]
                ]),
                _hoisted_67,
                _hoisted_68,
                _hoisted_69
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-3", {
                'label--active': _ctx.stepper == 4,
              }])
            }, [
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _createTextVNode(" Start Date(MM-DD-YYYY) "),
                  _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.stripeSubscriptionInfo.startDate), 1)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createTextVNode(" End Date(MM-DD-YYYY) "),
                  _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.stripeSubscriptionInfo.endDate), 1)
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createTextVNode(" Amount "),
                  _createElementVNode("span", _hoisted_77, " $ " + _toDisplayString(_ctx.stripeSubscriptionInfo.amount) + ".00 ", 1)
                ]),
                _hoisted_78,
                _createElementVNode("div", _hoisted_79, [
                  _createTextVNode(" Project "),
                  _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.selectedSite.siteName), 1)
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createTextVNode(" Customer Email "),
                  _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.selectedEmail), 1)
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createTextVNode(" Customer Address "),
                  _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.stripeCustomerInfo.address), 1)
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createTextVNode(" Customer City "),
                  _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.stripeCustomerInfo.city), 1)
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createTextVNode(" Customer ZipCode "),
                  _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.stripeCustomerInfo.zipCode), 1)
                ])
              ])
            ], 2)
          ])
        ]),
        (_ctx.payNow)
          ? (_openBlock(), _createBlock(_component_stripe_checkout, {
              key: 0,
              ref: "checkoutRef",
              mode: "payment",
              pk: _ctx.publishableKey,
              "session-id": _ctx.sessionId
            }, null, 8, ["pk", "session-id"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_89, [
        (_ctx.fieldsError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(_ctx.fieldsMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn--secontary",
          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        }, " Cancel "),
        (_ctx.stepper != 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn--secontary",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
            }, " Back "))
          : _createCommentVNode("", true),
        (_ctx.stepper == 1 ||_ctx.stepper == 2||_ctx.stepper == 3)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn--primary",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.continueStep && _ctx.continueStep(...args))),
              disabled: _ctx.isContinueDisabled()
            }, " Continue ", 8, _hoisted_91))
          : (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "btn btn--primary",
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.doStripeSubscription && _ctx.doStripeSubscription(...args)))
            }, " Submit "))
      ])
    ])
  ]))
}